import { registerMerchant } from './merchant'
import { registerAdmin } from './admin'
import { registerUtils } from './utils'
import { registerAntd } from '@klook/admin-cli-service'
import { registerI18n } from './i18n'

export default async function registerPlugins(ctx) {
  const { isMerchant } = ctx

  // 注册公共插件
  await registerUtils(ctx)
  await registerI18n(ctx)

  if (isMerchant) {
    await registerMerchant(ctx)
  } else {
    await registerAdmin(ctx)
  }

  await registerAntd(ctx)

  return ctx
}
